import { FormattedMessage } from 'react-intl';
import { isNumber, isString } from 'lodash';

import { DeliverySection } from '../delivery-section';
import { StoreInfo } from '../../../../../../common/store-info';
import { EcpStoreType } from '../../../../../../../rest/ecp-locator';
import { IDeliveryStoreProps } from './delivery-store.models';
import { useStyles } from './delivery-store.styles';

export const DeliveryStore = ({
  storeData, withBorder, isFulfilledOrder,
}: IDeliveryStoreProps): JSX.Element => {
  const classes = useStyles();

  return (
    <DeliverySection
      name="store"
      title={isFulfilledOrder ? (
        <FormattedMessage id="order.delivery.fulfilled.message" />
      ) : null }
      withBorder={withBorder}
      withoutTopIndent
    >
      <StoreInfo
        name={isString(storeData.name) ? storeData.name : ''}
        rating={storeData.rating == null ? null : Number(storeData.rating)}
        type={storeData.type as EcpStoreType}
        distance={isNumber(storeData.distance) ? storeData.distance : 0}
        street={isString(storeData.street) ? storeData.street : ''}
        openinghours={isString(storeData.openinghours) ? storeData.openinghours : ''}
        phonenumber={isString(storeData.phonenumber) ? storeData.phonenumber : ''}
        titleStyles={classes.paragraph}
        isDeliveryStore
        contentStyles={classes.contentStyles}
      />
    </DeliverySection>
  );
};
